<template>
  <BFormCheckbox :name="`checkbox-${ data.value }`"
                 :value="data.value"
                 @change="$emit('change')">
    {{ data.text }}
    <InfoIconWithTooltip :title="tr('performanceOverview.NOT_TODAY')"></InfoIconWithTooltip>
  </BFormCheckbox>
</template>

<script>
  import { BFormCheckbox } from 'bootstrap-vue';
  import InfoIconWithTooltip from '../../../../common/layout/InfoIconWithTooltip.vue';
  import { translator } from '~/zf/frontend/common/mixins';

  export default {
    name: 'SettingUnavailableToday',
    components: {
      InfoIconWithTooltip,
      BFormCheckbox,
    },
    mixins: [translator],
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    emits: ['change'],
  };
</script>
